import { createCustomEnum } from "./customEnum";

const OrderNumberTypes = createCustomEnum({
	None: {
		value: 0,
		name: "none",
		displayName: "None",
	},
	Restaurant: {
		value: 1,
		name: "Restaurant",
		displayName: "Restaurant",
	},
	Retail: {
		value: 2,
		name: "Retail",
		displayName: "Retail",
	},
});

export default OrderNumberTypes;
